import Additives from './Additives';
import Allergens from './Allergens';
import Coupons from './Coupons';

export default {
  Additives,
  Allergens,
  Coupons,
};
